import React from 'react'

function Students() {
  return (
    <div>Students</div>
  )
}

export default Students